// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"3201cc2a","601":"31796709"}[chunkId] + ".chunk.js";
};